import { InputAdornment, TextField, TextFieldProps } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
        },
        input: {
            textAlign: 'center',
            appearance: 'textfield',
            MozAppearance: 'textfield',
            WebkitAppearance: 'textfield',
            '& input[type=number]': {
                '-moz-appearance': 'textfield'
            },
            '& input[type=number]::-webkit-outer-spin-button': {
                '-webkit-appearance': 'none',
                margin: 0
            },
            '& input[type=number]::-webkit-inner-spin-button': {
                '-webkit-appearance': 'none',
                margin: 0
            }
        },
        iconButton: {
            padding: 10,
            color: theme.palette.primary.main
        },
        divider: {
            height: 26,
            margin: 4,
        },
    }),
);

export type IncrementingNumberInputProps = {
    onChange: React.Dispatch<number | undefined>,
    min?: number
    max?: number
} & Omit<TextFieldProps, 'onChange'>

const IncrementingNumberInput: React.FC<IncrementingNumberInputProps> = ({ onChange, min = 0, max, ...props }) => {
    const classes = useStyles();
    const v = (props.value as number) || 0

    const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        const val = parseInt(e.target.value)

        if (val && max) {
            if (val > max) onChange(max)
        }

        if (val <= min) {
            return onChange(min)
        }

        return onChange(val)
    }

    return <TextField
        {...props}
        type='number'
        className={classes.input}
        variant='outlined'
        onChange={handleChange}
        disabled={max === 0}
        InputProps={{
            inputProps: { className: classes.input },
            startAdornment: (
                <InputAdornment position="start">
                    <IconButton disabled={v <= min} tabIndex={-1} className={classes.iconButton} onClick={() => onChange(v - 1)}>
                        <RemoveCircleIcon />
                    </IconButton>
                    <Divider className={classes.divider} orientation="vertical" />
                </InputAdornment>
            ),
            endAdornment: (
                <InputAdornment position="end">
                    <Divider className={classes.divider} orientation="vertical" />
                    <IconButton disabled={max ? v >= max : false} tabIndex={-1} className={classes.iconButton} onClick={() => onChange(v + 1)}>
                        <AddCircleIcon />
                    </IconButton>
                </InputAdornment>
            ),
        }}
    />
}

export default IncrementingNumberInput
